import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page-heading" }
const _hoisted_3 = { class: "toolbar partner-list-actions" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 1,
  class: "notice error"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "partner-browser" }
const _hoisted_8 = { class: "partner-text-filters" }
const _hoisted_9 = ["onKeydown"]
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "multi-integration-filter" }
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "partner-filter-actions" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "panel partner-table-wrap" }
const _hoisted_18 = { class: "table-panel partner-table" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "compact-list-cell" }
const _hoisted_21 = { class: "compact-list-cell" }
const _hoisted_22 = { class: "number-column" }
const _hoisted_23 = { class: "number-column" }
const _hoisted_24 = { class: "number-column" }
const _hoisted_25 = {
  key: 0,
  class: "category-cell"
}
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 0,
  class: "loading"
}
const _hoisted_28 = { class: "pagination" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { class: "jira-modal partner-card-modal" }
const _hoisted_32 = { class: "jira-modal-header" }
const _hoisted_33 = ["title"]
const _hoisted_34 = { class: "jira-modal-layout" }
const _hoisted_35 = { class: "jira-main" }
const _hoisted_36 = { class: "entity-tabs" }
const _hoisted_37 = { class: "jira-section partner-summary-section" }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = {
  key: 1,
  class: "partner-summary-editor"
}
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "jira-section partner-comments" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { class: "partner-comment-list" }
const _hoisted_44 = { class: "activity-avatar" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "jira-section" }
const _hoisted_47 = { class: "jira-section partner-relations-section" }
const _hoisted_48 = {
  key: 1,
  class: "jira-section activity-section"
}
const _hoisted_49 = { class: "activity-feed" }
const _hoisted_50 = { class: "activity-avatar" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { class: "history-diff" }
const _hoisted_53 = { class: "diff-old" }
const _hoisted_54 = { class: "diff-new" }
const _hoisted_55 = {
  key: 0,
  class: "empty-related-tasks"
}
const _hoisted_56 = {
  key: 2,
  class: "jira-section activity-section presence-section"
}
const _hoisted_57 = { class: "activity-feed" }
const _hoisted_58 = { class: "activity-avatar" }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = {
  key: 0,
  class: "presence-account-name"
}
const _hoisted_61 = {
  key: 0,
  class: "empty-related-tasks"
}
const _hoisted_62 = { class: "jira-sidebar" }
const _hoisted_63 = { class: "field-block" }
const _hoisted_64 = { class: "field-readonly" }
const _hoisted_65 = { class: "editable-field-row" }
const _hoisted_66 = { class: "editable-field-row" }
const _hoisted_67 = { class: "editable-field-row" }
const _hoisted_68 = { class: "field-block partner-taxonomy" }
const _hoisted_69 = { class: "multi-picker" }
const _hoisted_70 = ["value"]
const _hoisted_71 = { class: "multi-picker" }
const _hoisted_72 = ["value"]
const _hoisted_73 = { class: "field-block" }
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { class: "field-block" }
const _hoisted_76 = {
  key: 0,
  class: "field-block"
}
const _hoisted_77 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[41] || (_cache[41] = _createElementVNode("div", null, [
        _createElementVNode("small", null, "CRM"),
        _createElementVNode("h1", null, "Партнёры")
      ], -1 /* CACHED */)),
      _createElementVNode("button", {
        class: "primary",
        onClick: _cache[0] || (_cache[0] = $event => ($setup.showCreate=true))
      }, "+ Создать партнёра")
    ]),
    ($setup.showCreate)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          class: "inline-create",
          onSubmit: _withModifiers($setup.createPartner, ["prevent"])
        }, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.newPartner.name) = $event)),
            placeholder: "Название",
            required: ""
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $setup.newPartner.name]
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.newPartner.website) = $event)),
            placeholder: "Сайт"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $setup.newPartner.website]
          ]),
          _cache[42] || (_cache[42] = _createElementVNode("button", { class: "primary" }, "Создать", -1 /* CACHED */)),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[3] || (_cache[3] = $event => ($setup.showCreate=false))
          }, "Отмена")
        ], 32 /* NEED_HYDRATION */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "export-link",
        disabled: $setup.exporting,
        onClick: $setup.downloadExport
      }, _toDisplayString($setup.exporting ? "Экспорт…" : "Экспорт CSV"), 9 /* TEXT, PROPS */, _hoisted_4)
    ]),
    ($setup.exportError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($setup.exportError), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("button", {
      class: _normalizeClass(["mobile-filter-toggle", {active:$setup.filtersOpen}]),
      onClick: _cache[4] || (_cache[4] = $event => ($setup.filtersOpen=!$setup.filtersOpen))
    }, [
      _cache[43] || (_cache[43] = _createTextVNode("⚙ Фильтры ", -1 /* CACHED */)),
      (Number(Boolean($setup.filters.q.trim())) + $setup.filters.category_ids.length + $setup.filters.stage_ids.length)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(Number(Boolean($setup.filters.q.trim())) + $setup.filters.category_ids.length + $setup.filters.stage_ids.length), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("aside", {
        class: _normalizeClass(["partner-filters panel", {open:$setup.filtersOpen}])
      }, [
        _createElementVNode("header", null, [
          _cache[44] || (_cache[44] = _createElementVNode("strong", null, "Фильтры", -1 /* CACHED */)),
          _createElementVNode("button", { onClick: $setup.clearFilters }, "Сбросить")
        ]),
        _createElementVNode("section", _hoisted_8, [
          _cache[46] || (_cache[46] = _createElementVNode("h3", null, "Универсальный поиск", -1 /* CACHED */)),
          _createElementVNode("label", null, [
            _cache[45] || (_cache[45] = _createTextVNode("Значения", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.filters.q) = $event)),
              rows: "4",
              placeholder: "Название, email, Telegram, ID, описание…",
              onKeydown: _withKeys(_withModifiers($setup.applyFilters, ["ctrl","prevent"]), ["enter"])
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_9), [
              [_vModelText, $setup.filters.q]
            ])
          ]),
          _cache[47] || (_cache[47] = _createElementVNode("small", null, "Несколько вариантов — через запятую или с новой строки. Слова внутри одного варианта ищутся одновременно.", -1 /* CACHED */))
        ]),
        _createElementVNode("section", null, [
          _cache[50] || (_cache[50] = _createElementVNode("h3", null, "Интеграция", -1 /* CACHED */)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.filters.connection_id) = $event)),
            onChange: $setup.applyFilters
          }, [
            _cache[48] || (_cache[48] = _createElementVNode("option", { value: "" }, "Все интеграции", -1 /* CACHED */)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.integrations, (item) => {
              return (_openBlock(), _createElementBlock("option", {
                key: item.id,
                value: item.id
              }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_10))
            }), 128 /* KEYED_FRAGMENT */))
          ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
            [_vModelSelect, $setup.filters.connection_id]
          ]),
          _createElementVNode("label", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($setup.filters.multiple_integrations) = $event)),
              type: "checkbox",
              onChange: $setup.applyFilters
            }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
              [_vModelCheckbox, $setup.filters.multiple_integrations]
            ]),
            _cache[49] || (_cache[49] = _createTextVNode("Более одной интеграции", -1 /* CACHED */))
          ])
        ]),
        _createElementVNode("section", null, [
          _cache[51] || (_cache[51] = _createElementVNode("h3", null, "Категория", -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.categories, (item) => {
            return (_openBlock(), _createElementBlock("label", {
              key: item.id
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.filters.category_ids) = $event)),
                type: "checkbox",
                value: item.id,
                onChange: $setup.applyFilters
              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_12), [
                [_vModelCheckbox, $setup.filters.category_ids]
              ]),
              _createElementVNode("span", {
                class: "stage-dot",
                style: _normalizeStyle({background:item.color})
              }, null, 4 /* STYLE */),
              _createTextVNode(_toDisplayString(item.name), 1 /* TEXT */),
              _createElementVNode("small", null, _toDisplayString($setup.categoryCounts[item.id] || 0), 1 /* TEXT */)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createElementVNode("section", null, [
          _cache[52] || (_cache[52] = _createElementVNode("h3", null, "Стадия", -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stages, (item) => {
            return (_openBlock(), _createElementBlock("label", {
              key: item.id
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($setup.filters.stage_ids) = $event)),
                type: "checkbox",
                value: item.id,
                onChange: $setup.applyFilters
              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_13), [
                [_vModelCheckbox, $setup.filters.stage_ids]
              ]),
              _createTextVNode(_toDisplayString(item.name), 1 /* TEXT */)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createElementVNode("section", null, [
          _cache[54] || (_cache[54] = _createElementVNode("h3", null, "Доступность", -1 /* CACHED */)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($setup.filters.available) = $event)),
            onChange: $setup.applyFilters
          }, [...(_cache[53] || (_cache[53] = [
            _createElementVNode("option", { value: "" }, "Любая", -1 /* CACHED */),
            _createElementVNode("option", { value: "true" }, "Доступен", -1 /* CACHED */),
            _createElementVNode("option", { value: "false" }, "Недоступен", -1 /* CACHED */)
          ]))], 544 /* NEED_HYDRATION, NEED_PATCH */), [
            [_vModelSelect, $setup.filters.available]
          ])
        ]),
        _createElementVNode("section", null, [
          _cache[56] || (_cache[56] = _createElementVNode("h3", null, "Менеджер", -1 /* CACHED */)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($setup.filters.manager_id) = $event)),
            onChange: $setup.applyFilters
          }, [
            _cache[55] || (_cache[55] = _createElementVNode("option", { value: "" }, "Все", -1 /* CACHED */)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.users, (item) => {
              return (_openBlock(), _createElementBlock("option", {
                key: item.id,
                value: item.id
              }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_14))
            }), 128 /* KEYED_FRAGMENT */))
          ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
            [_vModelSelect, $setup.filters.manager_id]
          ])
        ]),
        _createElementVNode("footer", _hoisted_15, [
          _createElementVNode("button", {
            class: "primary",
            disabled: $setup.loading,
            onClick: $setup.applyFilters
          }, _toDisplayString($setup.loading ? "Применяем…" : "Применить"), 9 /* TEXT, PROPS */, _hoisted_16)
        ])
      ], 2 /* CLASS */),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("table", null, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  class: "sortable",
                  onClick: _cache[12] || (_cache[12] = $event => ($setup.changeSort('name')))
                }, "Партнёр " + _toDisplayString($setup.sort==='name' ? ($setup.direction==='asc'?'↑':'↓') : ''), 1 /* TEXT */),
                _createElementVNode("th", {
                  class: "sortable",
                  onClick: _cache[13] || (_cache[13] = $event => ($setup.changeSort('email')))
                }, "Email " + _toDisplayString($setup.sort==='email' ? ($setup.direction==='asc'?'↑':'↓') : ''), 1 /* TEXT */),
                _cache[57] || (_cache[57] = _createElementVNode("th", null, "Источник трафика", -1 /* CACHED */)),
                _cache[58] || (_cache[58] = _createElementVNode("th", null, "ГЕО трафика", -1 /* CACHED */)),
                _cache[59] || (_cache[59] = _createElementVNode("th", { class: "number-column" }, "Игроки", -1 /* CACHED */)),
                _createElementVNode("th", {
                  class: "number-column sortable",
                  onClick: _cache[14] || (_cache[14] = $event => ($setup.changeSort('depositing_players_count','desc')))
                }, "С депозитами " + _toDisplayString($setup.sort==='depositing_players_count' ? ($setup.direction==='asc'?'↑':'↓') : ''), 1 /* TEXT */),
                _createElementVNode("th", {
                  class: "number-column sortable",
                  onClick: _cache[15] || (_cache[15] = $event => ($setup.changeSort('top_first_deposit_players_count','desc')))
                }, "Топ-FTD > €100 " + _toDisplayString($setup.sort==='top_first_deposit_players_count' ? ($setup.direction==='asc'?'↑':'↓') : ''), 1 /* TEXT */),
                _createElementVNode("th", {
                  class: "sortable",
                  onClick: _cache[16] || (_cache[16] = $event => ($setup.changeSort('category')))
                }, "Категория " + _toDisplayString($setup.sort==='category' ? ($setup.direction==='asc'?'↑':'↓') : ''), 1 /* TEXT */),
                _cache[60] || (_cache[60] = _createElementVNode("th", null, "Стадия", -1 /* CACHED */)),
                _cache[61] || (_cache[61] = _createElementVNode("th", null, "Доступность", -1 /* CACHED */)),
                _cache[62] || (_cache[62] = _createElementVNode("th", null, "Аккаунты", -1 /* CACHED */))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.items, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id,
                  class: "clickable",
                  onClick: $event => ($setup.open(item.id))
                }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("strong", null, _toDisplayString(item.name), 1 /* TEXT */),
                    _createElementVNode("small", null, _toDisplayString(item.website), 1 /* TEXT */)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.primary_email || "—"), 1 /* TEXT */),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(item.traffic_sources?.map(source=>source.name).join(', ') || '—'), 1 /* TEXT */)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(item.countries?.map(country=>country.code).join(', ') || '—'), 1 /* TEXT */)
                  ]),
                  _createElementVNode("td", _hoisted_22, [
                    _createElementVNode("strong", null, _toDisplayString(item.registered_players_count || 0), 1 /* TEXT */)
                  ]),
                  _createElementVNode("td", _hoisted_23, [
                    _createElementVNode("strong", null, _toDisplayString(item.depositing_players_count || 0), 1 /* TEXT */)
                  ]),
                  _createElementVNode("td", _hoisted_24, [
                    _createElementVNode("strong", null, _toDisplayString(item.top_first_deposit_players_count || 0), 1 /* TEXT */)
                  ]),
                  _createElementVNode("td", null, [
                    (item.category)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                          _createElementVNode("i", {
                            style: _normalizeStyle({background:item.category.color})
                          }, null, 4 /* STYLE */),
                          _createTextVNode(_toDisplayString(item.category.name), 1 /* TEXT */)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_26, "—"))
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: "lozenge",
                      style: _normalizeStyle({ '--color': item.stage?.color })
                    }, _toDisplayString(item.stage?.name || "—"), 5 /* TEXT, STYLE */)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(item.currently_available ? 'available' : 'unavailable')
                    }, "● " + _toDisplayString(item.currently_available ? "Доступен" : "Недоступен"), 3 /* TEXT, CLASS */)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.external_accounts_count || 0), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_19))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, "Загрузка…"))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("footer", _hoisted_28, [
          _createElementVNode("span", null, _toDisplayString($setup.total ? `${($setup.page-1)*$setup.perPage+1}–${Math.min($setup.page*$setup.perPage,$setup.total)} из ${$setup.total}` : "Нет партнёров"), 1 /* TEXT */),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              disabled: $setup.page===1,
              onClick: _cache[17] || (_cache[17] = $event => ($setup.changePage($setup.page-1)))
            }, "←", 8 /* PROPS */, _hoisted_29),
            _createElementVNode("strong", null, _toDisplayString($setup.page) + " / " + _toDisplayString($setup.totalPages), 1 /* TEXT */),
            _createElementVNode("button", {
              disabled: $setup.page===$setup.totalPages,
              onClick: _cache[18] || (_cache[18] = $event => ($setup.changePage($setup.page+1)))
            }, "→", 8 /* PROPS */, _hoisted_30)
          ])
        ])
      ])
    ]),
    ($setup.partner)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["jira-modal-backdrop", {'full-window':$setup.fullScreen}]),
          onClick: _withModifiers($setup.close, ["self"])
        }, [
          _createElementVNode("article", _hoisted_31, [
            _createElementVNode("header", _hoisted_32, [
              _createElementVNode("span", null, "CRM / Партнёры / " + _toDisplayString($setup.partner.id), 1 /* TEXT */),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  class: "window-toggle",
                  title: $setup.fullScreen ? 'Обычное окно' : 'Открыть на весь экран',
                  onClick: _cache[19] || (_cache[19] = $event => ($setup.fullScreen=!$setup.fullScreen))
                }, _toDisplayString($setup.fullScreen ? '❐' : '□'), 9 /* TEXT, PROPS */, _hoisted_33),
                _createElementVNode("button", {
                  class: "close",
                  onClick: $setup.close
                }, "×")
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("main", _hoisted_35, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => (($setup.edit.name) = $event)),
                  class: "jira-title-input",
                  "aria-label": "Название партнёра"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.edit.name]
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("button", {
                    class: _normalizeClass({active:$setup.detailTab==='details'}),
                    onClick: _cache[21] || (_cache[21] = $event => ($setup.detailTab='details'))
                  }, "Карточка", 2 /* CLASS */),
                  _createElementVNode("button", {
                    class: _normalizeClass({active:$setup.detailTab==='activity'}),
                    onClick: _cache[22] || (_cache[22] = $event => ($setup.detailTab='activity'))
                  }, [
                    _cache[63] || (_cache[63] = _createTextVNode("Изменения ", -1 /* CACHED */)),
                    _createElementVNode("span", null, _toDisplayString($setup.activity.length), 1 /* TEXT */)
                  ], 2 /* CLASS */),
                  _createElementVNode("button", {
                    class: _normalizeClass({active:$setup.detailTab==='presence'}),
                    onClick: _cache[23] || (_cache[23] = $event => ($setup.detailTab='presence'))
                  }, [
                    _cache[64] || (_cache[64] = _createTextVNode("Наличие ", -1 /* CACHED */)),
                    _createElementVNode("span", null, _toDisplayString($setup.presenceLog.length), 1 /* TEXT */)
                  ], 2 /* CLASS */)
                ]),
                ($setup.detailTab==='details')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("section", _hoisted_37, [
                        _createElementVNode("header", null, [
                          _createElementVNode("h3", null, _toDisplayString($setup.tr('summary')), 1 /* TEXT */),
                          (!$setup.editingSummary)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                onClick: _cache[24] || (_cache[24] = $event => ($setup.editingSummary=true))
                              }, "✎ Редактировать"))
                            : _createCommentVNode("v-if", true)
                        ]),
                        (!$setup.editingSummary)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "partner-summary-view",
                              role: "button",
                              tabindex: "0",
                              onClick: _cache[25] || (_cache[25] = $event => ($setup.editingSummary=true)),
                              onKeydown: _cache[26] || (_cache[26] = _withKeys($event => ($setup.editingSummary=true), ["enter"]))
                            }, [
                              ($setup.edit.summary)
                                ? (_openBlock(), _createBlock($setup["RichContent"], {
                                    key: 0,
                                    html: $setup.edit.summary
                                  }, null, 8 /* PROPS */, ["html"]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_38, "Добавьте краткое описание партнёра…")),
                              _cache[65] || (_cache[65] = _createElementVNode("small", null, "Нажмите на описание, чтобы изменить", -1 /* CACHED */))
                            ], 32 /* NEED_HYDRATION */))
                          : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                              _createVNode($setup["RichTextEditor"], {
                                modelValue: $setup.edit.summary,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => (($setup.edit.summary) = $event))
                              }, null, 8 /* PROPS */, ["modelValue"]),
                              _createElementVNode("div", null, [
                                _createElementVNode("button", {
                                  class: "primary",
                                  disabled: $setup.saving,
                                  onClick: $setup.saveSummary
                                }, _toDisplayString($setup.saving ? "…" : $setup.tr('save')), 9 /* TEXT, PROPS */, _hoisted_40),
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: $setup.cancelSummary
                                }, "Отмена")
                              ])
                            ]))
                      ]),
                      _createElementVNode("section", _hoisted_41, [
                        _createElementVNode("header", null, [
                          _createElementVNode("h3", null, _toDisplayString($setup.tr('comments')), 1 /* TEXT */),
                          _createElementVNode("span", null, _toDisplayString($setup.partner.comments.length), 1 /* TEXT */),
                          (!$setup.commentEditorOpen)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "comment-open-button",
                                onClick: _cache[28] || (_cache[28] = $event => ($setup.commentEditorOpen=true))
                              }, "+ Добавить комментарий"))
                            : _createCommentVNode("v-if", true)
                        ]),
                        ($setup.commentEditorOpen)
                          ? (_openBlock(), _createElementBlock("form", {
                              key: 0,
                              class: "comment-form",
                              onSubmit: _withModifiers($setup.comment, ["prevent"])
                            }, [
                              _createVNode($setup["RichTextEditor"], {
                                modelValue: $setup.commentBody,
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => (($setup.commentBody) = $event)),
                                placeholder: "Добавьте комментарий…"
                              }, null, 8 /* PROPS */, ["modelValue"]),
                              _createElementVNode("div", null, [
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: _cache[30] || (_cache[30] = $event => {$setup.commentEditorOpen=false;$setup.commentBody=''})
                                }, "Отмена"),
                                _createElementVNode("button", {
                                  class: "primary",
                                  disabled: !$setup.commentBody
                                }, "Добавить комментарий", 8 /* PROPS */, _hoisted_42)
                              ])
                            ], 32 /* NEED_HYDRATION */))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("div", _hoisted_43, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.partner.comments, (item) => {
                            return (_openBlock(), _createElementBlock("article", {
                              key: item.id,
                              class: "partner-comment"
                            }, [
                              _createElementVNode("div", _hoisted_44, _toDisplayString((item.user?.name || 'С').slice(0,1)), 1 /* TEXT */),
                              _createElementVNode("div", null, [
                                _createElementVNode("header", null, [
                                  _createElementVNode("strong", null, _toDisplayString(item.user?.name || 'Система'), 1 /* TEXT */),
                                  _createVNode($setup["DualTime"], {
                                    value: item.created_at
                                  }, null, 8 /* PROPS */, ["value"])
                                ]),
                                _createVNode($setup["RichContent"], {
                                  html: item.body
                                }, null, 8 /* PROPS */, ["html"])
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */)),
                          (!$setup.partner.comments.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_45, "Комментариев пока нет"))
                            : _createCommentVNode("v-if", true)
                        ])
                      ]),
                      _createElementVNode("section", _hoisted_46, [
                        _createVNode($setup["PartnerMetricsChart"], {
                          series: $setup.partner.metric_series
                        }, null, 8 /* PROPS */, ["series"])
                      ]),
                      _createElementVNode("section", _hoisted_47, [
                        _cache[66] || (_cache[66] = _createElementVNode("h3", null, "Связи и задачи", -1 /* CACHED */)),
                        _createVNode($setup["PartnerRelations"], {
                          "partner-id": $setup.partner.id,
                          links: $setup.partner.links,
                          tasks: $setup.partner.tasks,
                          onRefresh: _cache[31] || (_cache[31] = $event => ($setup.loadPartner($setup.partner.id)))
                        }, null, 8 /* PROPS */, ["partner-id", "links", "tasks"])
                      ])
                    ], 64 /* STABLE_FRAGMENT */))
                  : ($setup.detailTab==='activity')
                    ? (_openBlock(), _createElementBlock("section", _hoisted_48, [
                        _cache[69] || (_cache[69] = _createElementVNode("h3", null, "История изменений", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_49, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.activity, (item) => {
                            return (_openBlock(), _createElementBlock("article", {
                              key: item.id,
                              class: "activity-item"
                            }, [
                              _createElementVNode("div", _hoisted_50, _toDisplayString((item.actor?.name || 'С').slice(0,1)), 1 /* TEXT */),
                              _createElementVNode("div", null, [
                                _createElementVNode("header", null, [
                                  _createElementVNode("strong", null, _toDisplayString(item.actor?.name || 'Система'), 1 /* TEXT */),
                                  _cache[67] || (_cache[67] = _createElementVNode("span", null, "изменил карточку", -1 /* CACHED */)),
                                  (item.metadata?.integration_name)
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_51, _toDisplayString(item.metadata.integration_name), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true),
                                  _createVNode($setup["DualTime"], {
                                    value: item.at
                                  }, null, 8 /* PROPS */, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_52, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.changeset, (values, field) => {
                                    return (_openBlock(), _createElementBlock("div", { key: field }, [
                                      _createElementVNode("strong", null, _toDisplayString($setup.historyLabels[field] || field), 1 /* TEXT */),
                                      _createElementVNode("span", _hoisted_53, _toDisplayString($setup.historyValue(field,values[0])), 1 /* TEXT */),
                                      _cache[68] || (_cache[68] = _createElementVNode("span", { class: "diff-arrow" }, "→", -1 /* CACHED */)),
                                      _createElementVNode("span", _hoisted_54, _toDisplayString($setup.historyValue(field,values[1])), 1 /* TEXT */)
                                    ]))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ])
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */)),
                          (!$setup.activity.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_55, "Изменений пока нет"))
                            : _createCommentVNode("v-if", true)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("section", _hoisted_56, [
                        _cache[70] || (_cache[70] = _createElementVNode("h3", null, "Журнал наличия в интеграциях", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_57, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.presenceLog, (item) => {
                            return (_openBlock(), _createElementBlock("article", {
                              key: item.id,
                              class: "activity-item presence-item"
                            }, [
                              _createElementVNode("div", _hoisted_58, _toDisplayString(item.action === 'partner_missing' ? '−' : item.action === 'partner_returned' ? '↩' : '+'), 1 /* TEXT */),
                              _createElementVNode("div", null, [
                                _createElementVNode("header", null, [
                                  _createElementVNode("strong", null, _toDisplayString($setup.presenceLabels[item.action] || item.action), 1 /* TEXT */),
                                  _createElementVNode("small", null, [
                                    _createTextVNode(_toDisplayString($setup.providerLabel(item.provider)), 1 /* TEXT */),
                                    (item.external_id)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(" #" + _toDisplayString(item.external_id), 1 /* TEXT */)
                                        ], 64 /* STABLE_FRAGMENT */))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  (item.metadata?.integration_name)
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_59, _toDisplayString(item.metadata.integration_name), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true),
                                  _createVNode($setup["DualTime"], {
                                    value: item.at
                                  }, null, 8 /* PROPS */, ["value"])
                                ]),
                                (item.account_name)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(item.account_name), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true)
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */)),
                          (!$setup.presenceLog.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_61, "Событий наличия пока нет"))
                            : _createCommentVNode("v-if", true)
                        ])
                      ]))
              ]),
              _createElementVNode("aside", _hoisted_62, [
                _createElementVNode("section", _hoisted_63, [
                  _createElementVNode("h3", null, _toDisplayString($setup.tr('details')), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_64, [
                    _cache[71] || (_cache[71] = _createElementVNode("span", null, "Доступность", -1 /* CACHED */)),
                    _createElementVNode("strong", {
                      class: _normalizeClass($setup.partner.currently_available ? 'available' : 'unavailable')
                    }, "● " + _toDisplayString($setup.partner.currently_available ? "Доступен" : "Недоступен"), 3 /* TEXT, CLASS */)
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("span", null, _toDisplayString($setup.tr('category')), 1 /* TEXT */),
                    _createVNode($setup["InlineSelect"], {
                      modelValue: $setup.edit.category_id,
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => (($setup.edit.category_id) = $event)),
                      options: $setup.categories,
                      "allow-empty": "",
                      onChange: $setup.savePartner
                    }, null, 8 /* PROPS */, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("span", null, _toDisplayString($setup.tr('stage')), 1 /* TEXT */),
                    _createVNode($setup["InlineSelect"], {
                      modelValue: $setup.edit.stage_id,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => (($setup.edit.stage_id) = $event)),
                      options: $setup.stages,
                      onChange: $setup.savePartner
                    }, null, 8 /* PROPS */, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("span", null, _toDisplayString($setup.tr('manager')), 1 /* TEXT */),
                    _createVNode($setup["InlineSelect"], {
                      modelValue: $setup.edit.manager_id,
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => (($setup.edit.manager_id) = $event)),
                      options: $setup.users,
                      "allow-empty": "",
                      onChange: $setup.savePartner
                    }, null, 8 /* PROPS */, ["modelValue", "options"])
                  ])
                ]),
                _createElementVNode("section", _hoisted_68, [
                  _cache[74] || (_cache[74] = _createElementVNode("h3", null, "Трафик", -1 /* CACHED */)),
                  _createElementVNode("details", _hoisted_69, [
                    _createElementVNode("summary", null, [
                      _cache[72] || (_cache[72] = _createElementVNode("span", null, "ГЕО трафика", -1 /* CACHED */)),
                      _createElementVNode("strong", null, _toDisplayString($setup.edit.country_ids?.length ? `${$setup.edit.country_ids.length} выбрано` : 'Не указано'), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => (($setup.geoSearch) = $event)),
                        placeholder: "Найти страну…"
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, $setup.geoSearch]
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredCountries, (item) => {
                        return (_openBlock(), _createElementBlock("label", {
                          key: item.id
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => (($setup.edit.country_ids) = $event)),
                            type: "checkbox",
                            value: item.id,
                            onChange: $setup.savePartner
                          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_70), [
                            [_vModelCheckbox, $setup.edit.country_ids]
                          ]),
                          _createElementVNode("span", null, _toDisplayString(item.code), 1 /* TEXT */),
                          _createTextVNode(_toDisplayString(item.name_ru || item.name_en), 1 /* TEXT */)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ]),
                  _createElementVNode("details", _hoisted_71, [
                    _createElementVNode("summary", null, [
                      _cache[73] || (_cache[73] = _createElementVNode("span", null, "Источник трафика", -1 /* CACHED */)),
                      _createElementVNode("strong", null, _toDisplayString($setup.edit.traffic_source_ids?.length ? `${$setup.edit.traffic_source_ids.length} выбрано` : 'Не указано'), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = $event => (($setup.trafficSourceSearch) = $event)),
                        placeholder: "Найти источник…"
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, $setup.trafficSourceSearch]
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredTrafficSources, (item) => {
                        return (_openBlock(), _createElementBlock("label", {
                          key: item.id
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => (($setup.edit.traffic_source_ids) = $event)),
                            type: "checkbox",
                            value: item.id,
                            onChange: $setup.savePartner
                          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_72), [
                            [_vModelCheckbox, $setup.edit.traffic_source_ids]
                          ]),
                          _createTextVNode(_toDisplayString(item.name), 1 /* TEXT */)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ])
                ]),
                _createElementVNode("section", _hoisted_73, [
                  _createElementVNode("h3", null, _toDisplayString($setup.tr('integrations')), 1 /* TEXT */),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.partner.external_accounts, (account) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `${account.provider}-${account.id}`,
                      class: "integration-block"
                    }, [
                      _createElementVNode("strong", null, _toDisplayString(account.integration_name), 1 /* TEXT */),
                      _createElementVNode("span", null, _toDisplayString(account.name) + " · " + _toDisplayString(account.provider === 'referon' ? 'ReferOn' : 'Affilka') + " #" + _toDisplayString(account.external_id), 1 /* TEXT */),
                      _createElementVNode("span", null, _toDisplayString(account.status || account.state), 1 /* TEXT */),
                      (account.provider === 'referon')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_74, _toDisplayString([account.email, account.telegram, account.skype].filter(Boolean).join(' · ')), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("span", {
                        class: _normalizeClass(account.currently_available ? 'available' : 'unavailable')
                      }, _toDisplayString(account.currently_available ? "Доступен" : "Недоступен"), 3 /* TEXT, CLASS */)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _createElementVNode("section", _hoisted_75, [
                  _createElementVNode("h3", null, _toDisplayString($setup.tr('contacts')), 1 /* TEXT */),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.partner.contacts, (contact) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: contact.id,
                      class: "contact-row"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(contact.kind) + " · " + _toDisplayString(contact.value), 1 /* TEXT */),
                      _createElementVNode("small", null, _toDisplayString(contact.editable ? "CRM" : "Импорт"), 1 /* TEXT */)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */)),
                  _createElementVNode("form", {
                    class: "contact-form",
                    onSubmit: _withModifiers($setup.addContact, ["prevent"])
                  }, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[39] || (_cache[39] = $event => (($setup.newContact.kind) = $event))
                    }, [...(_cache[75] || (_cache[75] = [
                      _createElementVNode("option", null, "email", -1 /* CACHED */),
                      _createElementVNode("option", null, "phone", -1 /* CACHED */),
                      _createElementVNode("option", null, "telegram", -1 /* CACHED */),
                      _createElementVNode("option", null, "skype", -1 /* CACHED */),
                      _createElementVNode("option", null, "ms_teams", -1 /* CACHED */)
                    ]))], 512 /* NEED_PATCH */), [
                      [_vModelSelect, $setup.newContact.kind]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => (($setup.newContact.value) = $event)),
                      placeholder: "Контакт",
                      required: ""
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, $setup.newContact.value]
                    ]),
                    _cache[76] || (_cache[76] = _createElementVNode("button", null, "+", -1 /* CACHED */))
                  ], 32 /* NEED_HYDRATION */)
                ]),
                ($setup.partner.merge_candidates?.length)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_76, [
                      _cache[77] || (_cache[77] = _createElementVNode("h3", null, "Возможные совпадения", -1 /* CACHED */)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.partner.merge_candidates, (candidate) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: candidate.id,
                          class: "merge-candidate"
                        }, [
                          _createElementVNode("span", null, _toDisplayString(candidate.name), 1 /* TEXT */),
                          _createElementVNode("button", {
                            onClick: $event => ($setup.merge(candidate))
                          }, "Объединить", 8 /* PROPS */, _hoisted_77)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ])
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ]))
}